<template>
  <div class="clearfix form-horizontal">
    <h2 class="step-name">Forecast Lepto Program</h2>

    <div class="step-section">
      <h3 class="text-left">Lepto Products Purchased</h3>
      <div v-if="model.CHARTS.sr_lepto_purchases.length > 0 ">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Purchase Date</th>
              <th>Animal</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lp, index) in model.CHARTS.sr_lepto_purchases" :key="index">
              <td class="text-left">{{ lp[0] }}</td>
              <td class="text-left">{{ lp[1] }}</td>
              <td class="text-left">{{ lp[2] }}</td>
              <td class="text-left">{{ lp[3] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p class="text-left">No Results</p>
      </div>
    </div>

    <div class="step-section">
      <div class="clearfix" :style="{ width: widthForRow(model.FARMS) + 'px' }">
        <div v-for="farm in model.FARMS" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <fieldset>
            <legend>
              <span class="form-group"> Lepto Vaccination details from Winter Consult </span>
            </legend>

            <div class="form-group">
              <label for="lepto_calves_date_1">Calves First Vax Date</label>
              <input type="date" v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_1`]"
                                class="form-control" id="lepto_calves_date_1" disabled>

              <span v-show="errors.has(`farm_${farm.id}-lepto_calves_date_1`)" class="text-danger">
                {{ errors.first(`farm_${farm.id}-lepto_calves_date_1`) }}
              </span>
            </div>
            <div class="form-group">
              <label for="lepto_calves_date_2">Calves Second Vax Date</label>
              <input type="date" v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_2`]"
                                class="form-control" id="lepto_calves_date_2"  disabled>
            </div>
            <div class="form-group">
              <label for="lepto_calves_date_3">Calves Third Vax Date</label>
              <input type="date" v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_3`]"
                                class="form-control" id="lepto_calves_date_3"  disabled>
            </div>

            <div class="form-group">
              <label for="lepto_heifers_date">
                Heifers Vax Date
              </label>
              <p>Select product in Drug Allocations below</p>
              <input type="date" v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_heifers_date`]"
                                class="form-control" id="lepto_heifers_date"  disabled>
            </div>

            <div class="form-group">
              <label for="lepto_herd_date">
                Herd Vax Date
              </label>
              <p>Select product in Drug Allocations below</p>
              <input type="date" v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_herd_date`]"
                                class="form-control" id="lepto_herd_date"  disabled>
            </div>

            <div class="form-group">
              <label>Lepto Certificate Required?</label>
              <div class="radio">
                <label class="radio-inline">
                  <input type="radio" v-model="model.previous_winter_consult[`farm_${farm.id}-wants_lepto_cert`]" :value="'Yes'" disabled>Yes
                </label>
                <label class="radio-inline">
                  <input type="radio" v-model="model.previous_winter_consult[`farm_${farm.id}-wants_lepto_cert`]" :value="'No'" disabled>No
                </label>
              </div>
            </div>

            <div class="form-group">
              <label for="lepto_vax_program">
                Programme Type?
              </label>
              <select class="form-control" id="lepto_vax_program"  v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_vax_program`]" disabled>
                <option value="Vet Vaccinated">Vet Vaccinated</option>
                <option value="Lepto QA">Lepto QA</option>
                <option value="Lepto QA Vet Vaccinated">Lepto QA Vet Vaccinated</option>
                <option value="Does not vaccinate">Does not vaccinate</option>
              </select>
            </div>

            <div class="form-group">
              <label for="lepto_vax_completed_in">
                Vaccination Completed in?
              </label>
              <select class="form-control" id="lepto_vax_completed_in"  v-model="model.previous_winter_consult[`farm_${farm.id}-lepto_vax_completed_in`]" disabled>
                <option value="May">May</option>
                <option value="December">December</option>
                <option value="Not Applicable">Not Applicable</option>
              </select>
            </div>

            <div class="form-group">
              <label for="pigs_on_farm">Numbers of Pigs on Farm?</label>
              <input type="number" v-model="model.previous_winter_consult[`farm_${farm.id}-pigs_on_farm`]" class="form-control" id="pigs_on_farm" disabled>
            </div>
          </fieldset>
        </div>
      </div>
    </div>

    <div class="row step-section">
      <div class="col-md-6">
        <div class="form-group">
          <label class="col-sm-3">
            Do you need 7 in 1 / lepto?
            <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          </label>
          <div class="col-sm-6">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="wants_lepto" v-model="model.wants_lepto" :value="'Yes'" :disabled="isReadOnly">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" name="wants_lepto" v-model="model.wants_lepto" :value="'No'" :disabled="isReadOnly">No
              </label>
            </div>
            <span v-show="errors.has('wants_lepto')" class="text-danger">{{ errors.first('wants_lepto') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="lepto_product" class="col-sm-3"> Product </label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="lepto_product" id="lepto_product" v-model="model.lepto_product" data-vv-as="product" :disabled="isReadOnly">
            <span v-show="errors.has('lepto_product')" class="text-danger">{{ errors.first('lepto_product') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="lepto_doses" class="col-sm-3">Doses</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="lepto_doses" id="lepto_doses" v-model="model.lepto_doses" data-vv-as="doses" :disabled="isReadOnly">
            <span v-show="errors.has('lepto_doses')" class="text-danger">{{ errors.first('lepto_doses') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="lepto_needle" class="col-sm-3">Needle</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="lepto_needle" id="lepto_needle" v-model="model.lepto_needle" data-vv-as="needle" :disabled="isReadOnly">
            <span v-show="errors.has('lepto_needle')" class="text-danger">{{ errors.first('lepto_needle') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="lepto_guns" class="col-sm-3">Guns</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="lepto_guns" id="lepto_guns" v-model="model.lepto_guns" data-vv-as="guns" :disabled="isReadOnly">
            <span v-show="errors.has('lepto_guns')" class="text-danger">{{ errors.first('lepto_guns') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="lepto_delivery" class="col-sm-3">Pick up/ Delivery</label>
          <div class="col-sm-9">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="lepto_delivery" v-model="model.lepto_delivery" :value="'Pick up'" :disabled="isReadOnly">Pick up
              </label>
              <label class="radio-inline">
                <input type="radio" name="lepto_delivery" v-model="model.lepto_delivery" :value="'Delivery'" :disabled="isReadOnly">Delivery
              </label>
            </div>
            <span v-show="errors.has('lepto_delivery')" class="text-danger">{{ errors.first('lepto_delivery') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row step-section">
      <div class="col-md-6">
        <div class="form-group">
          <label class="col-sm-3">
            Do you want drench?
            <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          </label>
          <div class="col-sm-6">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="wants_drench" v-model="model.wants_drench" :value="'Yes'"
                       :disabled="isReadOnly">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" name="wants_drench" v-model="model.wants_drench" :value="'No'"
                       :disabled="isReadOnly">No
              </label>
            </div>
            <span v-show="errors.has('wants_drench')" class="text-danger">{{ errors.first('wants_drench') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="drench_product" class="col-sm-3">Product</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="drench_product" id="drench_product" v-model="model.drench_product" data-vv-as="product" :disabled="isReadOnly">
            <span v-show="errors.has('drench_product')" class="text-danger">{{ errors.first('drench_product') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="drench_doses" class="col-sm-3">Doses</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="drench_doses" id="drench_doses" v-model="model.drench_doses" data-vv-as="doses" :disabled="isReadOnly">
            <span v-show="errors.has('drench_doses')" class="text-danger">{{ errors.first('drench_doses') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="drench_needle" class="col-sm-3">Needle</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="drench_needle" id="drench_needle" v-model="model.drench_needle" data-vv-as="needle" :disabled="isReadOnly">
            <span v-show="errors.has('drench_needle')" class="text-danger">{{ errors.first('drench_needle') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="drench_guns" class="col-sm-3">Guns</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="drench_guns" id="drench_guns" v-model="model.drench_guns" data-vv-as="guns" :disabled="isReadOnly">
            <span v-show="errors.has('drench_guns')" class="text-danger">{{ errors.first('drench_guns') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="drench_delivery" class="col-sm-3">Pick up/ Delivery</label>
          <div class="col-sm-9">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="drench_delivery" v-model="model.drench_delivery" :value="'Pick up'" :disabled="isReadOnly">Pick up
              </label>
              <label class="radio-inline">
                <input type="radio" name="drench_delivery" v-model="model.drench_delivery" :value="'Delivery'" :disabled="isReadOnly">Delivery
              </label>
            </div>
            <span v-show="errors.has('drench_delivery')" class="text-danger">{{ errors.first('drench_delivery') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row step-section">
      <div class="col-md-6">
        <div class="form-group">
          <label class="col-sm-3">
            Do you require trace elements?
            <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          </label>
          <div class="col-sm-6">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="wants_te" v-model="model.wants_te" :value="'Yes'" 
                       :disabled="isReadOnly">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" name="wants_te" v-model="model.wants_te" :value="'No'" 
                       :disabled="isReadOnly">No
              </label>
            </div>
            <span v-show="errors.has('wants_te')" class="text-danger">{{ errors.first('wants_te') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="te_product" class="col-sm-3">Product</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="te_product" id="te_product"
              v-model="model.te_product" data-vv-as="product" :disabled="isReadOnly">

            <span v-show="errors.has('te_product')" class="text-danger">{{ errors.first('te_product') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="te_doses" class="col-sm-3">Doses</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="te_doses" id="te_doses" 
              v-model="model.te_doses" data-vv-as="doses" :disabled="isReadOnly">

            <span v-show="errors.has('te_doses')" class="text-danger">{{ errors.first('te_doses') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="te_needle" class="col-sm-3">Needle</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="te_needle" id="te_needle"
              v-model="model.te_needle" data-vv-as="needle" :disabled="isReadOnly">

            <span v-show="errors.has('te_needle')" class="text-danger">{{ errors.first('te_needle') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="te_guns" class="col-sm-3">Guns</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" name="te_guns" id="te_guns"
              v-model="model.te_guns" data-vv-as="guns" :disabled="isReadOnly">

            <span v-show="errors.has('te_guns')" class="text-danger">{{ errors.first('te_guns') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="te_delivery" class="col-sm-3">Pick up/ Delivery</label>
          <div class="col-sm-9">
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" name="te_delivery" v-model="model.te_delivery" :value="'Pick up'" :disabled="isReadOnly">Pick up
              </label>
              <label class="radio-inline">
                <input type="radio" name="te_delivery" v-model="model.te_delivery" :value="'Delivery'" :disabled="isReadOnly">Delivery
              </label>
            </div>
            <span v-show="errors.has('te_delivery')" class="text-danger">{{ errors.first('te_delivery') }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        'wants_lepto': "",
        'lepto_product': "",
        'lepto_doses': "",
        'lepto_needle': "",
        'lepto_guns': "",
        'lepto_delivery': "",
        'wants_drench': "",
        'drench_product': "",
        'drench_doses': "",
        'drench_needle': "",
        'drench_guns': "",
        'drench_delivery': "",
        'wants_te': "",
        'te_product': "",
        'te_doses': "",
        'te_needle': "",
        'te_guns': "",
        'te_delivery': "",
        CHARTS: {
          sr_lepto_purchases: [],
        },
      },
    }
  },
  methods: {
    toggleNotifications: function() {
      if (this.model.wants_te == 'Yes' || this.model.wants_drench == 'Yes' || this.model.wants_lepto == 'Yes') {
        this.toggleNotification({slug: 'forecast-lepto-program-details', value: true})
      } else {
        this.toggleNotification({slug: 'forecast-lepto-program-details', value: false})
      }
    },
  },
}
</script>
